module.exports = __webpack_public_path__ + "static/media/libby6.0f5f0a73.png";